import helpers from '../../helpers';
import actionTypes from './constants';

/* */
const initialState = {
  events: [],
  status: [],
  entrants: [],
  comment: null,
  tournament: null,
  transaction: null,
};

/* */
const isAnonymous = (entrant) => entrant.reference === 'UNKNOWN' && entrant.type === 'anonymous';

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.enter.INITIALIZE: {
      return {
        ...initialState,
        ...action.payload,
      };
    }
    case actionTypes.enter.ADD_ENTRANT: {
      const { lastname: ln, firstname: fn } = action.payload;

      return {
        ...state,
        entrants: [
          ...state.entrants,
          {
            ...action.payload,
            lastname: ln ? ln.toUpperCase() : null,
            firstname: fn ? helpers.string.ucfirst(fn) : null,
          },
        ],
      };
    }
    case actionTypes.enter.ADJUST_ENTRANTS: {
      const entrants = helpers.object.deepClone(state.entrants);
      const index = state.entrants.findIndex((e) => isAnonymous(e));
      if (index === -1) {
        entrants.splice(-1, 1);
      } else {
        entrants.splice(index, 1);
      }
      return {
        ...state,
        entrants,
      };
    }
    case actionTypes.enter.REPLACE_ENTRANT: {
      const { lastname: ln, firstname: fn } = action.payload;
      const entrants = helpers.object.deepClone(state.entrants);

      if (action.index === null) {
        entrants.some((p, i) => {
          if (p.reference === 'UNKNOWN' && p.type === 'anonymous') {
            entrants[i] = {
              ...action.payload,
              lastname: ln ? ln.toUpperCase() : null,
              firstname: fn ? helpers.string.ucfirst(fn) : null,
            };
            return true;
          }
          return false;
        });
      } else {
        entrants[action.index] = {
          ...action.payload,
          lastname: ln ? ln.toUpperCase() : null,
          firstname: fn ? helpers.string.ucfirst(fn) : null,
        };
      }
      return {
        ...state,
        entrants,
      };
    }
    case actionTypes.enter.UPDATE_ENTER: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
};
